<div class="page-container">
  <h1>Datenschutzerklärung für Sparkly</h1>
    
  <h2>1. Verantwortliche Stelle</h2>
  <p>Die verantwortliche Stelle für die Verarbeitung Ihrer personenbezogenen Daten ist:</p>
  <p>Julian Wandel<br>
  Rathausstrasse 7<br>
  72127 Kusterdingen<br><br>
  {{'info@sparklycards.com'}}</p>
  
  <h2>2. Erhebung und Verarbeitung personenbezogener Daten</h2>
  <p>Wir erheben und verarbeiten Ihre Daten im Einklang mit den geltenden Datenschutzgesetzen.</p>
  
  <h3>a) Automatisch erhobene Daten:</h3>
  <ul>
      <li>Nutzungsdaten: Informationen über Ihre Nutzung der App (z. B. besuchte Seiten, Nutzungsdauer).</li>
      <li>Geräteinformationen: Geräte-ID, Betriebssystem, App-Version, IP-Adresse.</li>
      <li>Statistische Daten: Anonyme Nutzungsdaten, die mit Microsoft Clarity erhoben werden, um die App zu verbessern.</li>
  </ul>
  
  <h3>b) Daten, die Sie aktiv bereitstellen:</h3>
  <ul>
      <li>Registrierung: Vorname, E-Mail-Adresse</li>
      <li>Supportanfragen: Daten, die Sie bei einer Supportanfrage angeben.</li>
  </ul>
  
  <h3>c) App-spezifische Berechtigungen:</h3>
  <ul>
      <li>Push-Benachrichtigungen: Um Ihnen Updates und wichtige Informationen zu senden.</li>
  </ul>
  
  <h2>3. Drittanbieter-Tools und Dienste</h2>
  <p>Wir nutzen Drittanbieter-Tools, um die Funktionalität der App sicherzustellen und zu verbessern:</p>
  <ul>
      <li>Microsoft Clarity: Ein Analysetool zur Auswertung des Nutzerverhaltens. Daten werden anonym verarbeitet. Weitere Informationen: <a href="https://privacy.microsoft.com/de-de/privacystatement" target="_blank">https://privacy.microsoft.com/de-de/privacystatement</a>.</li>
      <li>Hotjar: Ein Analysetool zur Auswertung des Nutzerverhaltens. Daten werden anonym verarbeitet.</li>
      <li>Sentry: Ein Fehlerüberwachungstool zur Verbesserung der Stabilität der App. Es werden anonyme Informationen zu Abstürzen und Fehlern gesammelt. Weitere Informationen: <a href="https://sentry.io/privacy/" target="_blank">https://sentry.io/privacy/</a>.</li>
      <li>Hosting durch Strato: Unsere App wird von Strato gehostet, das Server-Log-Daten (z. B. IP-Adressen) verarbeitet. Weitere Informationen: <a href="https://www.strato.de/datenschutz/" target="_blank">https://www.strato.de/datenschutz/</a>.</li>
  </ul>
  
  <h2>4. Zweck der Datenverarbeitung</h2>
  <p>Wir verarbeiten Ihre Daten zu folgenden Zwecken:</p>
  <ul>
      <li>Bereitstellung und Verbesserung der Funktionalität der App.</li>
      <li>Personalisierung der Nutzererfahrung.</li>
      <li>Analyse und Verbesserung unserer Dienste (Microsoft Clarity).</li>
      <li>Erkennung und Behebung von Fehlern (Sentry).</li>
  </ul>
  
  <h2>5. Weitergabe von Daten an Dritte</h2>
  <p>Ihre Daten werden nur in folgenden Fällen an Dritte weitergegeben:</p>
  <ul>
      <li>Sie haben ausdrücklich zugestimmt.</li>
      <li>Es ist gesetzlich vorgeschrieben.</li>
      <li>Es ist notwendig, um unsere Dienste bereitzustellen (z. B. Hosting durch Strato, Nutzung von Clarity oder Sentry).</li>
  </ul>
  
  <h2>6. Speicherdauer</h2>
  <p>Ihre personenbezogenen Daten werden nur so lange gespeichert, wie es für die Zwecke der Verarbeitung erforderlich ist oder wie es gesetzliche Aufbewahrungsfristen vorschreiben.</p>
  
  <h2>7. Datensicherheit</h2>
  <p>Wir schützen Ihre Daten durch technische und organisatorische Maßnahmen, um Verlust, Missbrauch und unbefugten Zugriff zu verhindern.</p>
  
  <h2>8. Ihre Rechte</h2>
  <p>Sie haben folgende Rechte:</p>
  <ul>
      <li>Recht auf Auskunft: Informationen über die Verarbeitung Ihrer Daten zu erhalten.</li>
      <li>Recht auf Berichtigung: Korrektur Ihrer personenbezogenen Daten zu verlangen.</li>
      <li>Recht auf Löschung: Löschung Ihrer personenbezogenen Daten zu beantragen.</li>
      <li>Recht auf Einschränkung der Verarbeitung: Verarbeitung Ihrer Daten zu beschränken.</li>
      <li>Recht auf Datenübertragbarkeit: Ihre Daten in einem strukturierten, gängigen Format zu erhalten.</li>
      <li>Recht auf Widerspruch: Der Verarbeitung Ihrer Daten zu bestimmten Zwecken zu widersprechen.</li>
      <li>Recht auf Beschwerde: Beschwerde bei einer Aufsichtsbehörde einzulegen.</li>
  </ul>
  
  <h2>9. Kontakt</h2>
  <p>Wenn Sie Fragen haben oder Ihre Rechte ausüben möchten, kontaktieren Sie uns bitte:</p>
  <p>{{'info@sparklycards.com'}}</p>
  
  <h2>10. Aktualisierungen dieser Datenschutzerklärung</h2>
  <p>Wir können diese Datenschutzerklärung von Zeit zu Zeit aktualisieren. Sie können die neuesten Änderungen in unserer iOS-/Android-/Webapp einsehen.</p>
</div>